import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import Kiosk from './Kiosk';
import Sidebar from './Sidebar';

const PageContainer = ({ children, className, disableSidebar, id, style = {} }) => {
  const { fullscreen } = useSelector(state => state.page);

  return (
    <div id="page" className={classNames(className, fullscreen && 'fullscreen')} style={style}>
      <Kiosk />
      <Sidebar disabled={disableSidebar} />
      <div id={id} className="page-container">
        {children}
      </div>
    </div>
  );
};

PageContainer.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  disableSidebar: PropTypes.bool,
  id: PropTypes.string,
  style: PropTypes.object,
};

export default PageContainer;
